import { expectArray, expectBoolean, expectOptionalString, expectRecord, expectString } from "./schema";
import { parseRelationType } from "./guardian";
export const STUDENT_ABSENCE_NOTICE_STATUSES = ["active", "cancelled"];
function parseStringEnum(value, allowedValues, path) {
    const parsed = expectString(value, path);
    if (!allowedValues.includes(parsed)) {
        throw new Error(`${path} must be one of: ${allowedValues.join(", ")}`);
    }
    return parsed;
}
export function parseStudentAbsenceNoticeStatus(value, path = "studentAbsenceNoticeStatus") {
    return parseStringEnum(value, STUDENT_ABSENCE_NOTICE_STATUSES, path);
}
export function normalizeAbsenceNote(value, path = "note") {
    const normalized = expectOptionalString(value, path);
    if (normalized && normalized.length > 500) {
        throw new Error(`${path} must be at most 500 characters`);
    }
    return normalized;
}
export function parseReportStudentAbsenceRequest(value, path = "reportStudentAbsenceRequest") {
    const record = expectRecord(value, path);
    return {
        studentIds: expectArray(record.studentIds, expectString, `${path}.studentIds`),
        note: normalizeAbsenceNote(record.note, `${path}.note`)
    };
}
export function parseCancelStudentAbsenceRequest(value, path = "cancelStudentAbsenceRequest") {
    const record = expectRecord(value, path);
    return {
        studentIds: expectArray(record.studentIds, expectString, `${path}.studentIds`)
    };
}
export function parseFamilyOccurrenceAbsenceStudent(value, path = "familyOccurrenceAbsenceStudent") {
    const record = expectRecord(value, path);
    const absenceStatus = record.absenceStatus === "none"
        ? "none"
        : parseStudentAbsenceNoticeStatus(record.absenceStatus, `${path}.absenceStatus`);
    return {
        studentId: expectString(record.studentId, `${path}.studentId`),
        displayName: expectString(record.displayName, `${path}.displayName`),
        displayNameKana: expectOptionalString(record.displayNameKana, `${path}.displayNameKana`),
        relationType: parseRelationType(record.relationType, `${path}.relationType`),
        absenceStatus,
        isAbsent: expectBoolean(record.isAbsent, `${path}.isAbsent`),
        note: expectOptionalString(record.note, `${path}.note`),
        reportedAt: expectOptionalString(record.reportedAt, `${path}.reportedAt`),
        cancelledAt: expectOptionalString(record.cancelledAt, `${path}.cancelledAt`)
    };
}
export function parseFamilyOccurrenceAbsenceDetail(value, path = "familyOccurrenceAbsenceDetail") {
    const record = expectRecord(value, path);
    const occurrence = expectRecord(record.occurrence, `${path}.occurrence`);
    const lifecycleStatus = parseStringEnum(occurrence.lifecycleStatus, ["scheduled", "cancelled", "completed"], `${path}.occurrence.lifecycleStatus`);
    return {
        occurrence: {
            occurrenceId: expectString(occurrence.occurrenceId, `${path}.occurrence.occurrenceId`),
            lessonId: expectString(occurrence.lessonId, `${path}.occurrence.lessonId`),
            lessonTitle: expectString(occurrence.lessonTitle, `${path}.occurrence.lessonTitle`),
            occurrenceDate: expectString(occurrence.occurrenceDate, `${path}.occurrence.occurrenceDate`),
            startAt: expectString(occurrence.startAt, `${path}.occurrence.startAt`),
            endAt: expectString(occurrence.endAt, `${path}.occurrence.endAt`),
            studioName: expectOptionalString(occurrence.studioName, `${path}.occurrence.studioName`),
            publicNote: expectOptionalString(occurrence.publicNote, `${path}.occurrence.publicNote`),
            lifecycleStatus
        },
        canReportAbsence: expectBoolean(record.canReportAbsence, `${path}.canReportAbsence`),
        students: expectArray(record.students, parseFamilyOccurrenceAbsenceStudent, `${path}.students`),
        updatedAt: expectString(record.updatedAt, `${path}.updatedAt`)
    };
}
